module.exports = {"TXTCLI_Number":{"id":"TXTCLI_Number","defaultMessage":"Numéro","track":"Number"}}